import React, { useState, useEffect } from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';

function TreeNode({
  node, isExpandedAll, searchKeyword, searchPerformed, translate,
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isHighlighted, setIsHighlighted] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const {
    component_name, component_version, dependencies, extras
  } = node;

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    setIsExpanded(isExpandedAll);
  }, [isExpandedAll]);

  useEffect(() => {
    const keywordLower = searchKeyword.toLowerCase();
    const nameLower = component_name.toLowerCase();
    const hasMatchingChild = dependencies.some((child) => { return child.component_name.toLowerCase().includes(keywordLower); });
    if (searchPerformed && keywordLower && (nameLower.includes(keywordLower) || hasMatchingChild)) {
      setIsExpanded(true);
      setIsHighlighted(true);
    } else {
      setIsHighlighted(false);
    }
  }, [searchPerformed, searchKeyword, component_name, dependencies, isExpandedAll]);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = (e) => {
    e.stopPropagation();
    setIsPopupOpen(false);
  };

  if (dependencies.length === 0) {
    return (
      <ul className="tree_node">
        <li>
          <Icon name="minus square outline" style={{ opacity: '0.3' }} />
          <span
            className={`name ${isHighlighted ? 'highlight' : ''} ${extras ? 'clickable' : ''}`}
            onClick={() => { return (extras ? openPopup() : null); }}
            onKeyUp={() => { return (extras ? openPopup() : null); }}
          >
            {component_name}
          </span>
          <span className="version">{component_version}</span>
          {extras && (
            <Popup
              className="dependency_extra"
              open={isPopupOpen}
              onClose={(e) => { return closePopup(e); }}
              content={extras}
              on="click"
              trigger={<Icon name="info circle" style={{ paddingLeft: '5px' }} />}
            />
          )}
        </li>
      </ul>
    );
  }

  return (
    <ul className="tree_node">
      <li>
        <Icon
          name={isExpanded ? 'minus square outline' : 'plus square outline'}
          className="toggle"
          onClick={toggleExpand}
        />
        <span
          className={`name ${isHighlighted ? 'highlight' : ''} ${extras ? 'clickable' : ''}`}
          onClick={() => { return (extras ? openPopup() : null); }}
          onKeyUp={() => { return (extras ? openPopup() : null); }}
        >
          {component_name}
        </span>
        <span className="version">{component_version}</span>
        {extras && (
          <Popup
            className="dependency_extra"
            open={isPopupOpen}
            onClose={(e) => { return closePopup(e); }}
            content={extras}
            on="click"
            trigger={<Icon name="info circle" style={{ paddingLeft: '5px' }} />}
          />
        )}
      </li>
      {isExpanded
        && dependencies.map((child) => {
          return <TreeNode key={uuidv4()} node={child} isExpandedAll={isExpandedAll} searchKeyword={searchKeyword} searchPerformed={searchPerformed} translate={translate} />;
        })}
    </ul>
  );
}

export default TreeNode;
